import { render, staticRenderFns } from "./MultiSourceSelect.vue?vue&type=template&id=867a06b6"
import script from "./MultiSourceSelect.vue?vue&type=script&lang=js"
export * from "./MultiSourceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports